import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { UnlinkedVeterinaryUserDto } from '../../dtos/unlinked-veterinary-user.dto';

@Injectable()
export class UnlinkedVeterinaryUsersRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(organizationId: number): Observable<readonly UnlinkedVeterinaryUserDto[]> {
    return this.http.get<readonly UnlinkedVeterinaryUserDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.organizationClients.unlinkedVeterinaryUsers(organizationId)}`,
    );
  }
}
